
import collect from 'collect.js'

export default {
  props: {
    price: {
      type: Object,
      required: true,
    },
    split: {
      type: Number,
      default: 0,
    },
    fees: {
      type: [Array, null],
      default: null,
    },
    discount: {
      type: Number,
      default: 0,
    },
    voucher: {
      type: Number,
      default: 0,
    },
    markup: {
      type: Number,
      default: 0,
    },
    reservation: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    feesInclude() {
      return this.fees && this.fees.length
        ? this.fees.filter((value) => value.isIncluded === 'true')
        : null
    },
    feesNotInclude() {
      return this.fees && this.fees.length
        ? this.fees.filter((value) => value.isIncluded === 'false')
        : null
    },
    feesSum() {
      return collect(this.feesInclude).sum(
        (item) => item.client_price.amount_with_markup,
      )
    },
    fessTaxes() {
      return this.reservation.meta && this.reservation.meta.fees
        ? this.reservation.meta.fees.filter(
            (fee) => fee.IsIncludedInPrice === 'false',
          )
        : null
    },
  },
}
